import ActionModel from 'cio/models/action';
import { Edge, ParsedTreeBranchNode } from 'cio/models/campaign';

export type DropTargetItem =
  | {
      id: string;
      action: ActionModel;
      type: string;
      edge?: Edge;
      edges?: ParsedTreeBranchNode[];
    }
  | ParsedTreeBranchNode
  | Edge;

export type DropType = 'insertAtBranchEnd' | 'insertAtEdge' | 'insertBefore' | 'insertAfter';

export enum VWBTab {
  Build = 'build',
  Metrics = 'metrics',
}

export enum MouseMode {
  Highlight = 'highlight',
  Scroll = 'scroll',
}

export enum DragMode {
  Copy = 'copy',
  Move = 'move',
}
